import React from 'react';

function Gps() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8333 0.833344L10.8341 3.38501C13.8548 3.76691 16.2335 6.14592 16.615 9.16668H19.1666V10.8333L16.615 10.8342C16.2332 13.8546 13.8546 16.2332 10.8341 16.615L10.8333 19.1667H9.16665V16.615C6.14589 16.2335 3.76688 13.8549 3.38498 10.8342L0.833313 10.8333V9.16668H3.38498C3.76653 6.14565 6.14562 3.76656 9.16665 3.38501V0.833344H10.8333ZM9.99998 5.00001C7.23856 5.00001 4.99998 7.23859 4.99998 10C4.99998 12.7614 7.23856 15 9.99998 15C12.7614 15 15 12.7614 15 10C15 7.23859 12.7614 5.00001 9.99998 5.00001ZM11.6666 10C11.6666 9.07954 10.9205 8.33334 9.99998 8.33334C9.0795 8.33334 8.33331 9.07954 8.33331 10C8.33331 10.9205 9.0795 11.6667 9.99998 11.6667C10.9205 11.6667 11.6666 10.9205 11.6666 10Z"
        fill="black"
      />
    </svg>
  );
}

export default Gps;
